import React from 'react';
import styles from './ButtonWithIconUrlPosts.module.scss';
import clsx from 'clsx';
import { ReactComponent as IconArrowRight } from 'images/new-icons/primary-arrow-right.svg';
import { useActions } from 'store/useActions';
import Button from '../Button';

export const ButtonWithIconUrlPosts = ({ func, btnCallToActionName, disabled }) => {
  const { setIsButtonMenuVisible } = useActions();

  return (
    <Button
      className={clsx(styles.button)}
      onClick={() => {
        func();
        setIsButtonMenuVisible(false);
      }}
      disabled={disabled}
    >
      <p className={clsx(styles.buttonText)}>{btnCallToActionName}</p>
      <div>
        <IconArrowRight />
      </div>
    </Button>
  );
};
